import React from 'react';
import { Link } from 'react-router-dom';


const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: 'url(assets/img/bg-img.png)' }}></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>Privacy Policy</h1>
            <ul className="bread-crumb clearfix">
              <li><Link to="/">Home</Link></li>
              <li>Privacy Policy</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="service-details industries-details">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 content-side">
              <div className="service-details-content">
                <div className="content-three">
                  <div className="upper-box">
                    <h3>Privacy Policy</h3>
                    <p>
                      SNKB Berings is dedicated to safeguarding your personal information and privacy. This Privacy Policy pertains to the data we gather from various sources, including our official corporate website snkbberings.com and any interactions with our distributors or online services. We prioritize the privacy of our distributors, customers, and website visitors, incorporating this policy into our Terms of Use.
                    </p>
                    <br />
                    <p>
                      Our Privacy Policy outlines the personal data we collect during your interactions with us, whether online, offline, or in-person. It elucidates our data collection, usage, and sharing practices, along with measures taken to protect collected data.
                    </p>
                    <br />
                    <p>
                      Kindly review this Privacy Policy to comprehend how we handle the information obtained through our website. By accessing or using our website, you confirm that you are at least 18 years old and agree unconditionally to this policy. This policy may undergo periodic updates (refer to Changes to our Privacy Policy). Continued use of our website post-changes indicates acceptance of the revised policy, hence please check periodically for updates.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
